// src/features/notification/components/NotificationButton.tsx
import { ActionIcon, Badge, Popover } from '@mantine/core';
import { IconBell } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import NotificationList from './NotificationList';
import { useAuthStore } from '@/stores/authStore';
import { useNotificationStore } from '@/stores/notificationStore';
import { useMarkAllAsViewed } from '../services/useNotificationQueries';

export default function NotificationButton() {
    const [opened, setOpened] = useState(false);
    const { user } = useAuthStore();
    const markAllAsViewed = useMarkAllAsViewed();

    const {
        unreadCount,
        subscribeToNotifications,
        subscribeToNotificationDeletion,
        unsubscribeFromNotifications,
        unsubscribeFromNotificationDeletion,
        updateUnreadCount,
    } = useNotificationStore();

    // 컴포넌트 마운트 시 구독 시작, 언마운트 시 구독 해제
    useEffect(() => {
        if (user?.id) {
            // 초기 알림 개수 업데이트
            void updateUnreadCount(user.id);
            // 실시간 구독 시작
            void subscribeToNotifications(user.id);
            void subscribeToNotificationDeletion(user.id);
        }

        // 클린업 함수: 컴포넌트 언마운트 시 구독 해제
        return () => {
            void unsubscribeFromNotifications();
            void unsubscribeFromNotificationDeletion();
        };
    }, [
        user?.id,
        subscribeToNotifications,
        subscribeToNotificationDeletion,
        unsubscribeFromNotifications,
        unsubscribeFromNotificationDeletion,
        updateUnreadCount,
    ]);

    return (
        <Popover
            position="bottom-end"
            shadow="md"
            opened={opened}
            onChange={() => {
                setOpened(o => !o);
                void markAllAsViewed.mutate({ userId: user?.id || '' });
            }}
            width={340}
            radius="md"
        >
            <Popover.Target>
                <div
                    style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <ActionIcon
                        variant="subtle"
                        size="sm"
                        color="gray"
                        onClick={() => setOpened(o => !o)}
                    >
                        <IconBell size={18} />
                    </ActionIcon>
                    {unreadCount > 0 && (
                        <Badge
                            size="xs"
                            color="red"
                            variant="filled"
                            style={{
                                border: 'none',
                                position: 'absolute',
                                top: -5,
                                right: -5,
                                padding: '2px 4px',
                                minWidth: '14px',
                                height: '14px',
                            }}
                        >
                            {unreadCount > 99 ? '99+' : unreadCount}
                        </Badge>
                    )}
                </div>
            </Popover.Target>
            <Popover.Dropdown p={0}>
                <NotificationList
                    onClose={() => {
                        setOpened(false);
                        void markAllAsViewed.mutate({ userId: user?.id || '' });
                    }}
                />
            </Popover.Dropdown>
        </Popover>
    );
}
